import { useState, useEffect } from 'react';

export default function RaiseHandQueue({ raisedHands = [], onLowerHand, currentUserId, isOrganizer = false, onSelectSpeaker }) {
  const [queue, setQueue] = useState([]);

  useEffect(() => {
    // Sort by timestamp (who raised hand first)
    const sorted = [...raisedHands].sort((a, b) => a.timestamp - b.timestamp);
    setQueue(sorted);
  }, [raisedHands]);

  if (queue.length === 0) return null;

  return (
    <div className="fixed top-20 right-4 z-[60] bg-[#1c1c1e] rounded-2xl p-4 border border-[#2c2c2e] shadow-2xl max-w-xs">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-white flex items-center gap-2">
          <span className="text-xl">✋</span>
          Raised Hands ({queue.length})
        </h3>
      </div>

      <div className="space-y-2 max-h-64 overflow-y-auto">
        {queue.map((hand, index) => (
          <div
            key={hand.userId}
            className={`flex items-center justify-between p-3 rounded-lg transition-all ${
              hand.userId === currentUserId ? 'bg-yellow-500/20' : 'bg-[#2c2c2e]'
            } ${isOrganizer && hand.userId !== currentUserId ? 'cursor-pointer hover:bg-blue-600/30 hover:border-blue-500/50 border border-transparent' : ''}`}
            onClick={() => {
              if (isOrganizer && hand.userId !== currentUserId && onSelectSpeaker) {
                onSelectSpeaker(hand.userId);
              }
            }}
          >
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-6 h-6 rounded-full bg-yellow-500 text-black text-xs font-bold">
                {index + 1}
              </div>
              <div>
                <div className="text-sm font-medium text-white">{hand.userName}</div>
                <div className="text-xs text-[#8e8e93]">
                  {Math.floor((Date.now() - hand.timestamp) / 1000)}s ago
                </div>
              </div>
            </div>
            {hand.userId === currentUserId ? (
              <button
                onClick={() => onLowerHand(hand.userId)}
                className="text-xs text-red-500 hover:text-red-400 font-medium"
              >
                Lower
              </button>
            ) : isOrganizer && onSelectSpeaker ? (
              <div className="text-xs text-blue-400 font-medium">
                Click to unmute
              </div>
            ) : null}
          </div>
        ))}
      </div>

      <div className="mt-3 text-xs text-[#8e8e93] text-center">
        {isOrganizer ? 'Click to unmute speaker and mute others' : 'Organizer will manage speaking order'}
      </div>
    </div>
  );
}
